import React from 'react'
import { Navbar, NavItem, Image, Nav } from 'react-bootstrap'


export default function OrganizationBar(props) {
  const organizationId = props.organization_id || localStorage.getItem('organization_id')
  const organizationName = props.organization_name || localStorage.getItem('organization_name')
  const organizationLogo = props.organization_logo || localStorage.getItem('organization_logo')
  return (
    <Navbar
      staticTop
      style={{
        color: 'var(--org-navbar-text-color, #ffffff)',
        backgroundColor: 'var(--org-primary-color, #5563b8)',
        backgroundImage: 'linear-gradient(to bottom, var(--org-primary-color, #5563b8) 60%, rgba(28, 35, 40, 0.408))'
      }}
    >
        <Navbar.Header style={{fontSize: "100%" }}>
            <Navbar.Brand style={{ color: 'var(--org-navbar-text-color, #ffffff)', fontSize: "200%" }}>
              {organizationName ? organizationName : <a href={organizationId ? document.location.origin + `/login?organization_id=${organizationId}`: document.location.origin + '/login'} style={{color: 'var(--org-navbar-text-color, #ffffff)'}}>Back to login</a>}
            </Navbar.Brand>
        </Navbar.Header>
        <Nav pullRight>
            <NavItem className="organization-bar-logo-slot">
              {organizationId && organizationName ? <Image src={organizationLogo || `https://s3.amazonaws.com/hoop-organization-logo/${organizationId}_logo`} className="organization-bar-logo-image" circle />: ""}
            </NavItem>
        </Nav>
    </Navbar>
  )
}
